<template>
  <PButton
    class="flex items-center justify-center rounded-full font-semibold"
    :disabled="is_disabled || is_loading || null"
    :size="size"
    @click.stop="submit"
  >
    <div
      v-if="icon_name || is_loading"
      class="flex items-center justify-center"
    >
      <AppIcon
        v-if="!is_loading"
        :name="icon_name"
      />
      <AppIcon
        v-else
        name="solid-spinner"
        pulse
      />
    </div>
    <div>
      <slot
        v-if="is_loading"
        name="loadingText"
      >
        {{ $t('button.actions.loading') }}
      </slot>
      <slot v-else />
    </div>
  </PButton>
</template>

<script setup>
import { useRouter } from 'vue-router';

const actions_to_icon = Object.freeze({
  approve: 'solid-check',
  create: 'solid-plus',
  download: 'solid-download',
  invitation: 'solid-envelope',
  new: 'solid-plus',
  move: 'solid-shuffle',
  publish: 'regular-eye',
  save: 'regular-floppy-disk',
  send: 'solid-paper-plane',
  share: 'solid-share',
  sign: 'regular-signature',
  unpublish: 'regular-eye-slash',
  update: 'solid-save',
  upload: 'solid-upload',
  unlock: 'regular-unlock',
  info: 'regular-circle-info',
});

const props = defineProps({
  action: {
    type: String,
    default: null,
    validator: (prop) =>
      [
        'approve',
        'create',
        'download',
        'invitation',
        'new',
        'move',
        'publish',
        'save',
        'send',
        'share',
        'sign',
        'unpublish',
        'update',
        'upload',
        'unlock',
        'info',
      ].includes(prop),
  },
  is_disabled: { type: Boolean },
  is_loading: { type: Boolean },
  to: { type: Object, default: null },
  size: { type: String, default: 'small' },
});

const emit = defineEmits(['onClick']);

const router = useRouter();

const icon_name = actions_to_icon[props.action];

function submit() {
  if (props.is_loading || props.is_disabled) return;
  if (props.to) {
    router.push(props.to);
    return;
  }
  emit('onClick');
}
</script>
